import { checkIfValueIsEmpty } from "./utils";

const getEmptyFieldsFromTemplate = (
  template,
  form,
  additionalOptionalKeys = ["id"],
) => {
  const checkIfEmpty = (key, val) => {
    const field = template.find((f) => f.key === key);
    if (!field) return false; // if not in template -> not required
    if (field.optional) return false; // if optional -> not required
    if (field.condition && !field.condition(form)) return false; // if condition === false -> not required
    // if (!Object.keys(defaultForm).includes(field.key)) return false // if not in defaultForm -> not required
    if (additionalOptionalKeys.includes(field.key)) return false; // if in additionalOptionalKeys -> not required
    if (field.isEmpty) return field.isEmpty(val);
    if (field.type === "formlist")
      return (
        !val ||
        val.length === 0 ||
        val.some(
          (item) =>
            getEmptyFieldsFromTemplate(field.template || {}, item) !== null,
        )
      );
    return checkIfValueIsEmpty(val);
  };
  const emptyFields = Object.keys(form).filter((key) =>
    checkIfEmpty(key, form[key]),
  );
  return emptyFields.length > 0 ? emptyFields : null;
};

export const getDefaultFormFromTemplate = (template) => {
  const defaultForm = {};
  template.forEach((field) => {
    if (field.default === undefined || !field.key) return;
    defaultForm[field.key] = field.default;
  });
  template.forEach((field) => {
    if (field.default === undefined || !field.key) return;
    if (field.condition && !field.condition(defaultForm))
      defaultForm[field.key] = field.empty === undefined ? null : field.empty;
  });
  return defaultForm;
};

export const getEmptyFieldsErrorFromTemplate = (
  template,
  form,
  additionalOptionalKeys = ["id"],
) => {
  const emptyFields = getEmptyFieldsFromTemplate(
    template,
    form,
    additionalOptionalKeys,
  );
  return emptyFields
    ? `Error: Following fields are not filled: ${emptyFields}`
    : null;
};
